import { styled } from 'styled-components';
import { Divider } from 'antd';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 24px;
    gap: 24px;
    `;

export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 24px;
    margin-top: 24px;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: flex-start;
    }
`;

export const LeftSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const RightSection = styled.div`
    width: 100%;

    @media (min-width: 768px) {
        max-width: 320px;
    }
`;

export const StyledDivider = styled(Divider)`
    margin: 16px 0;
    border-color: ${({ theme }) => theme?.colors?.text?.muted};

    @media (min-width: 768px) {
        width: 123px;
        min-width: 0px;
        margin: 60px 0px;
        transform: rotate(90deg);
        border-bottom: 1px solid ${({ theme }) => theme?.colors?.text?.muted};
    }
`;

export const CollectionTitle = styled.h1`
    font-weight: bold;
    font-size: 1.5rem;
    text-align: left;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    margin: 0;
`;

export const CollectionDescription = styled.p`
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    font-size: 1rem;
    text-align: left;
    font-weight: 400;

    @media (max-width: 767px) {
        margin: 0;
    }
`; 